import { useEffect, useState } from 'react';
import { fetchCategories } from '../../../http/categoryAPI';
import ServiceCard from '../../ServiceCard';
import { Pagination } from "antd";
import '../../../styles/doctors.scss';


const Services = () => {
const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 3; // Show 3 doctors per page
  // console.log("categories",categories);

  const paginatedCategories = categories.length > 0 ? categories?.slice((currentPage - 1) * pageSize, currentPage * pageSize) : 'nothing';
  // console.log("paginatedCategories", paginatedCategories);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchCategories();
        console.log("categories",data);

        console.log("categories", data); setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);

   return (
    <div className="doctors-container service-bg">
      {categories.length > 0 && (
        <div className="doctors-section">
          {paginatedCategories.map((category, index) => (
            <ServiceCard key={index} service={category} />
          ))}
        </div>
      )}
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={categories.length}
        onChange={(page) => setCurrentPage(page)}
         />
        </div>
  );
};
export default Services;
